import { promiseImage } from "../../../misc/utils";
import data from "../../../data";
const onPanMove = (evt, pos) => state => {
  const x = evt.deltaX + pos.x;
  const y = evt.deltaY + pos.y;

  state.images.crop = {
    ...state.images.crop,
    x: x,
    y: y
  };

  return state;
};

const onPanEnd = (prevState, newPos) => {
  prevState.pos = { x: newPos.x, y: newPos.y };
  return prevState;
};

const onPinchMove = (evt, scale) => state => {
  const newScale = Math.min(Math.max(scale * evt.scale, 0.1), 10);
  state.images.crop.scale = newScale;
  return state;
};

const onPinchEnd = (prevState, newScale) => {
  prevState.scale = newScale;
  return prevState;
};

const onSlide = evt => state => {
  state.images.crop.scale = evt.currentTarget.value;
  return state;
};

const generateImage = async refs => {
  const mainImage = refs.imageRef.getBoundingClientRect();
  const cropWindow = refs.cropWindow.getBoundingClientRect();

  const canvas = document.getElementById("canvas1");
  const ctx = canvas.getContext("2d");
  const img = await promiseImage(refs.imageRef.src);

  const widthMultiplier = canvas.width / cropWindow.width;
  const heightMultiplier = canvas.height / cropWindow.height;

  const xPos = (mainImage.left - cropWindow.left) * widthMultiplier;
  const yPos = (mainImage.top - cropWindow.top) * heightMultiplier;

  const width = mainImage.width / cropWindow.width * canvas.width;
  const height = mainImage.height / cropWindow.height * canvas.height;

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, xPos, yPos, width, height);

  return canvas.toDataURL();
};

const photoSmallWarning = () => {
  return {
    title: data.copy("photoWarningSmallTitle"),
    description: data.copy("photoWarningSmall")
  };
};

const photoLargeWarning = () => {
  return {
    title: data.copy("photoWarningLargeTitle"),
    description: data.copy("photoWarningLarge")
  };
};

const checkImage = refs => state => {
  const mainImage = refs.imageRef.getBoundingClientRect();
  const cropWindow = refs.cropWindow.getBoundingClientRect();

  if (
    mainImage.width < cropWindow.width ||
    mainImage.height < cropWindow.height ||
    mainImage.left > cropWindow.left ||
    mainImage.top > cropWindow.top
  ) {
    state.warning = photoSmallWarning();
  } else if (mainImage.width > refs.imageRef.naturalWidth) {
    state.warning = photoLargeWarning();
  } else {
    state.warning = null;
  }

  return state;
};

const clearWarning = () => state => {
  state.warning = null;
  return state;
};

export const cropActions = {
  onPanMove,
  onPanEnd,
  onPinchMove,
  onPinchEnd,
  onSlide,
  generateImage,
  checkImage,
  clearWarning
};



// WEBPACK FOOTER //
// ./src/components/areas/CropPhoto/actions.js